import PropTypes from 'prop-types';
import React from 'react';
import { InfoMessage, PopOutChart } from 'sharedComponents';
import { apiCallStatus } from 'helpers/constants';
import { chartPlugins } from './constants';
import useChartConfig from './useChartConfig';
/*import {
    EnableUniqueScaling,
    LastSyncDate,
    PopOutButton,
    ResetZoomButton,
    withLeftButtonGroup,
    withPopOutRow,
    withRightButtonGroup
} from 'sharedComponents/Chart/headers';*/


const TrendChart = ({
    selectedTrendKPIs,
    selectedTrendsData,
    removeSelectedKpiLegend,
    trendDataLoadingStatus,
    userLimits,
    enableUniqueScaling,
    lastMeasurementTimeStampLabel,
    isZoomed,
    chartKey = '',
    reloadAllSelectedTrendKpiData,
    setIsZoomed,
    zoomInToSelectedTrendKpiData,
    yAxisTitleVisible,
    mainChartHeader,
    warningLevels,
    warningLines,
    conditionTrendIndicators,
    highErrorValue,
    highAlertLimitValue,
    lowErrorValue,
    lowAlertValue,
    unitGroupId,
    title,
    assetId,
    assetDetails,
    valueType,
    conditionTrendsData,
    conditionForecast,
    sharedXAxisMax,
    sharedForecastSeparatorX,
    chartRef
}) => {
    const resetServerZoom = () => {
        reloadAllSelectedTrendKpiData(assetId);
    };

    const zoomIn = (from, to) => {
        zoomInToSelectedTrendKpiData(assetId, from, to);
    };
    const graphOptions = useChartConfig(
        selectedTrendsData,
        userLimits,
        yAxisTitleVisible,
        removeSelectedKpiLegend,
        warningLevels,
        warningLines,
        conditionTrendIndicators,
        highErrorValue,
        highAlertLimitValue,
        lowErrorValue,
        lowAlertValue,
        unitGroupId,
        title,
        assetDetails,
        valueType,
        conditionTrendsData,
        conditionForecast,
        sharedXAxisMax,
        sharedForecastSeparatorX,
        isZoomed
    );

    /*const CustomHeader = withPopOutRow([
        withLeftButtonGroup([LastSyncDate, EnableUniqueScaling]),
        withRightButtonGroup([ResetZoomButton, PopOutButton])]);*/

    const hasData = !!selectedTrendsData?.length || !!conditionTrendsData?.length || trendDataLoadingStatus === apiCallStatus.LOADING;

    return (
        <PopOutChart
            hasKpi={!!selectedTrendKPIs?.length}
            renderNoKpi={() => <InfoMessage
                title='ABB.Powertrain.Frontend.chartNoKPIsSelected'
                text='ABB.Powertrain.Frontend.chartNoKPIsSelectedUserGuide' />}
            hasData={hasData}
            renderNoData={() => <InfoMessage
                title='ABB.Powertrain.Frontend.chartNoMeasurementData'
                text='ABB.Powertrain.Frontend.chartNoMeasurementDataUserGuide' />}
            enableUniqueScaling={enableUniqueScaling}
            lastMeasurementLabel={lastMeasurementTimeStampLabel}
            zoomInServer={zoomIn}
            useLocalTimeZoom={true}
            resetServerZoom={resetServerZoom}
            isZoomed={isZoomed}
            setIsZoomed={setIsZoomed}
            zoomInToSelectedTrendKpiData={zoomInToSelectedTrendKpiData}
            loadingStatus={trendDataLoadingStatus}
            options={graphOptions}
            modules={chartPlugins}
            container={chartKey}
            mainChartHeader={mainChartHeader}
            chartRef={chartRef}
        />
    );
};

TrendChart.propTypes = {
    reloadAllSelectedTrendKpiData: PropTypes.func,
    setIsZoomed: PropTypes.func,
    zoomInToSelectedTrendKpiData: PropTypes.func,
    selectedTrendKPIs: PropTypes.array,
    enableUniqueScaling: PropTypes.bool,
    lastMeasurementTimeStampLabel: PropTypes.string,
    selectedTrendsData: PropTypes.array,
    trendDataLoadingStatus: PropTypes.string,
    userLimits: PropTypes.array,
    isZoomed: PropTypes.bool,
    chartKey: PropTypes.string,
    yAxisTitleVisible: PropTypes.bool,
    warningLevels: PropTypes.array,
    warningLines: PropTypes.array,
    conditionTrendIndicators: PropTypes.array,
    highErrorValue: PropTypes.number,
    highAlertLimitValue: PropTypes.number,
    lowErrorValue: PropTypes.number,
    lowAlertValue: PropTypes.number,
    unitGroupId: PropTypes.number,
    title: PropTypes.string,
    assetDetails: PropTypes.object,
    valueType: PropTypes.string,
    removeSelectedKpiLegend: PropTypes.func,
    conditionTrendsData: PropTypes.array,
    conditionForecast: PropTypes.array,
    assetId: PropTypes.string,
    sharedXAxisMax: PropTypes.number,
    sharedForecastSeparatorX: PropTypes.number,
    mainChartHeader: PropTypes.elementType,
    chartRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.any })
    ]),
};

export default React.memo(TrendChart);
